import * as constants from "../constants/dvdConstants";
import actionCreators from "../../itemList/actions/tabbedMoviesActionCreators";

export default actionCreators(constants);
